import { useState } from "#imports";
export const useFilters = (id) => {
  const filters = useState(
    `filters-${id}`,
    () => ({})
  );
  const pagination = useState(
    `pagination-${id}`,
    () => ({
      page: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0
    })
  );
  return { filters, pagination };
};
